
const dateformat = function (date: any, fmt: string) { //author: meizz 
    var o:any = {
        "M+": date.getMonth() + 1, //月份 
        "d+": date.getDate(), //日 
        "h+": date.getHours(), //小时 
        "m+": date.getMinutes(), //分 
        "s+": date.getSeconds(), //秒 
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
        "S": date.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
		fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
// 当月第一天
const getMonthFirstDay = (time:string = ''):string => {
  let date = time ? new Date(time) : new Date();
  date.setDate(1);
  let month:string |number = parseInt(`${date.getMonth() + 1}`);
  let day:string |number = date.getDate();
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return date.getFullYear() + '-' + month + '-' + day;
}
//返回本月第一天到当天24时的时间戳
const getFirstNowLastDay = ():Array<number> => {
    let now = new Date();
    let strLink = "/";
    let year = now.getFullYear();
    let month:any = now.getMonth() + 1;
    let day:any = now.getDate();
    // if (month >= 1 && month <= 9) {
    //   month = "0" + month;
    // }
    // if (day >= 1 && day <= 9) {
    //   day = "0" + day;
    // }
    let firstDate:string = year + strLink + month + strLink + '1';
    let currentDate = year + strLink + month + strLink + day;
    //var lastDay = this.getLastDay(year, month);
    //var lastDate = year + strLink + month + strLink + lastDay;
    return [new Date(firstDate).getTime(),new Date(currentDate).getTime()];
}
//返回上月第一天到当天24时的时间戳
const getLastMonthDay = ()=>{
    let nowdays = new Date();
    let year = nowdays.getFullYear();
    let month = nowdays.getMonth();
    if(month==0){
        month = 12;
        year = year-1;

    }
    if (month > 12) {//月份大于12划为下一年
        month = 1;
        year = year+1;
    }
    if(month<10){
        month = Number('0'+month);
    }

    let myDate = new Date(year,month,0);

    let startDate = year+'-'+month+'-01 00:00:00'; //上个月第一天
    let endDate = year+'-'+month+'-'+myDate.getDate();//上个月最后一天
    return [new Date(startDate).getTime(),new Date(endDate).getTime()];
}

export {
	dateformat,
  getMonthFirstDay,
        getFirstNowLastDay,
    getLastMonthDay
}